import { z } from 'zod';

export const PageQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(25),
  cursor: z.string().optional(),
  q: z.string().trim().min(1).optional(),
});

export type PageQuery = z.infer<typeof PageQuerySchema>;

export const PageMetaSchema = z.object({
  nextCursor: z.string().nullable(),
  hasMore: z.boolean(),
  limit: z.number().int().min(1).max(100),
});

export type PageMeta = z.infer<typeof PageMetaSchema>;

/** Filtered row count (cursor excluded) so the UI can render numbered pages (spec 0006). */
export const PageMetaWithTotalSchema = PageMetaSchema.extend({
  total: z.number().int(),
});

export type PageMetaWithTotal = z.infer<typeof PageMetaWithTotalSchema>;

export const encodeCursor = (createdAt: Date | string, id: string): string => {
  const isoDate = typeof createdAt === 'string' ? createdAt : createdAt.toISOString();
  return Buffer.from(`${isoDate}|${id}`, 'utf8').toString('base64url');
};

export interface DecodedCursor {
  createdAt: string;
  id: string;
}

export const decodeCursor = (cursor: string): DecodedCursor | null => {
  try {
    const decoded = Buffer.from(cursor, 'base64url').toString('utf8');
    const sepIdx = decoded.indexOf('|');
    if (sepIdx < 0) return null;
    const createdAt = decoded.slice(0, sepIdx);
    const id = decoded.slice(sepIdx + 1);
    if (!createdAt || !id) return null;
    if (Number.isNaN(Date.parse(createdAt))) return null;
    return { createdAt, id };
  } catch {
    return null;
  }
};
